import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../../service-call-utils.service';
import { constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class FilterOneService {
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de obtener todas las provincias segun la tecnologia
   * Autor: Luis Hernandez
   * @param technology tecnologia a consultar
   * @return Provincias
   */
  get_province(technology) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_PROVINCE, { "technology": technology });
  }

  /**
   * Description: Método que llama el servicio web para obtener todos los cantones de una provincia en especifico
   * Autor: Luis Hernandez
   * @param province provincia a consultar
   * @return Cantones
   */
  get_cantons(province){
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_CANTON, { "province": province });
  }


  /**
   * Description: Método que llama el servicio web para obtener todas las parroquias de un canton en especifico
   * Autor: Luis Hernandez
   * @param canton canton a consultar
   * @return Parroquias
   */
  get_parish(canton){
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_PARISH, { "canton": canton });
  }

  



  
}
